import { slugify } from "./slugify";

import { SearchState } from "../contexts/types";

/**
 * Gerar a URL formatada com base no estado da busca.
 * @param {SearchState} searchState - O estado da busca.
 * @returns {string} A URL formatada.
 */
export const composeURL = (searchState: SearchState): string => {
  if (!searchState.origin || !searchState.destination) return "/";

  const originSlug = slugify(searchState.origin.name);
  const destinationSlug = slugify(searchState.destination.name);

  let queryParams = `origin-airport=${searchState.origin.code}&destination-airport=${searchState.destination.code}`;

  if (searchState.departureDates?.length) {
    queryParams += `&departure-date=${searchState.departureDates.join(",")}`;
  }
  if (searchState.returnDates?.length && searchState.tripType !== "oneWay") {
    queryParams += `&return-date=${searchState.returnDates.join(",")}`;
  }

  queryParams += `&quantity-of-adults=${searchState.adults}`;
  queryParams += `&quantity-of-children=${searchState.children}`;
  queryParams += `&quantity-of-babies=${searchState.babies}`;

  const totalRequests =
    (searchState.departureDates?.length || 0) +
    (searchState.returnDates?.length || 0);
  queryParams += `&total-expected-requests=${totalRequests || 1}`;

  return `/passagens-aereas-de-${originSlug}/${searchState.origin.code}/para-${destinationSlug}/${searchState.destination.code}?${queryParams}`;
};
